import * as Css from "./style";

import Navbar from "../navbar";
import { BasePageProps } from "./basePageType";

export default function BasePage({children}: BasePageProps){
    return(
        <Css.ContainerPage>
            <Navbar/>
            <Css.ContainerContent>
                {children}
            </Css.ContainerContent>
        </Css.ContainerPage>
    )
}